<script>
import { mapState } from 'pinia';
import { useCartStore } from '../stores/cart.js';

export default {
    computed: {
        ...mapState(useCartStore, ['list'])
    },
    mounted() {
        const cartStore = useCartStore();
        cartStore.setup();
    }
};
</script>

<template>
    <div class="counter" v-if="list.length > 0">
        <span class="quantity">
            {{ list.length }}
        </span>
    </div>
</template>